<template>
  <v-container class="fill-height flex-column justify-center vers-background">
    <v-alert type="error" v-if="browserTooOld">
      {{ $t('app.browser.tooOld') }}
    </v-alert>
    <v-alert type="error" v-if="logoutReason" dismissible>
      {{ $t(logoutReason) }}
    </v-alert>
    <v-card max-width="320">
      <v-container class="pb-0">
        <v-col>
          <v-form
            class="pb-0"
            ref="form"
            @keyup.native.enter="loginAndRedirect"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <img
                alt="VERS"
                class="vers-fill-width"
                contain
                src="/img/logo.png"
              />
            </v-row>
            <v-row>
              <p class="text--secondary mb-0 mt-4">
                {{ $t('workshop.title') }}: {{ workshopName }}
              </p>
            </v-row>
            <v-row>
              <v-text-field
                :label="$t('login.username')"
                :rules="[rules.required]"
                autocomplete="username"
                filled
                v-model="userData.userName"
              />
            </v-row>

            <v-row>
              <v-text-field
                :label="$t('login.password')"
                :rules="[rules.required]"
                autocomplete="current-password"
                filled
                type="password"
                v-model="userData.password"
              />
            </v-row>

            <v-fab-transition>
              <v-btn
                @click="loginAndRedirect"
                light
                fab
                fixed
                :disabled="browserTooOld"
                bottom
                right
                color="primary"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-form>
        </v-col>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import userService from '../service/userService';
import { mapMutations, mapState } from 'vuex';

export default {
  methods: {
    ...mapMutations(['setLoading']),
    unpackPath(to) {
      if (to.query.redirect) {
        const location = this.$router.match(to.query.redirect);
        if (location) {
          return this.unpackPath(location);
        }
        return to.path;
      }
      return to.path;
    },
    async loginAndRedirect() {
      const loginSuccessful = await userService.login(
        this.$store.state,
        this.userData
      );
      if (loginSuccessful) {
        let goToRoot = async () => {
          await this.$router.push('/');
        };
        if (this.$route.query.redirect) {
          const unpackedPath = this.unpackPath(this.$route);
          if (unpackedPath === '/login') {
            await goToRoot();
          } else await this.$router.push(unpackedPath);
        } else await goToRoot();
        await this.$store.dispatch('initApp', true);
      } else {
        this.onNotification({
          message: this.$t('login.error'),
          color: 'error',
        });
      }
    },
    async getSideId() {
      const response = await userService.getSideId();
      if (response && response.status === 200) {
        this.workshopName = response.data.workshopName;
      } else if (response && response.status === 404) {
        //invalid siteId
        window.location = 'https://www.vpihamburg.de/vers/vers-tool';
      }
    },
    ...mapMutations({
      onNotification: 'snackbar/onNotification',
    }),
  },
  mounted() {
    this.setLoading(false);
    this.getSideId();
  },
  computed: {
    ...mapState(['logoutReason', 'authenticated']),
    browserTooOld() {
      return (
        this.$browserDetect.isIE ||
        (this.$browserDetect.isEdge && this.$browserDetect.meta.version < 19)
      );
    },
  },
  data() {
    return {
      valid: false,
      userData: {
        userName: '',
        password: '',
      },
      workshopName: '',
      rules: {
        required: (value) => !!value || this.$t('validation.required'),
      },
    };
  },
  name: 'LoginView.vue',
};
</script>

<style lang="css" scoped>
.vers-background {
  background: url('~/assets/background.png') no-repeat center center / cover;
  max-width: 100%;
}

.vers-fill-width {
  width: 100%;
  height: 100%;
}
</style>
